module.exports = __webpack_public_path__ + "img/image014.0c13948e.png";